import Tooltip from '@anm/components/Tooltip';
import { media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import { TopPlayerStatusesWrapper } from '../Wrapper';

import { BadgeTooltipProps, TooltipDescriptionProps, TooltipLinkProps } from './types';

const topPlayerStatusesMobile = media.phone`
  display: none;
`;

const tooltipText = css`
  margin: 0;
  color: #fff;
  font-size: 14px;
  line-height: 22px;
`;

export const TooltipDescription = styled.p<TooltipDescriptionProps>`
  ${tooltipText};
  display: ${({ isInline }) => (isInline ? 'inline-block' : 'block')};
`;

export const TooltipLink = styled.span<TooltipLinkProps>`
  ${tooltipText};
  color: var(--blue_100);
  cursor: pointer;
  display: inline-block;
  margin: ${({ margin }) => margin && margin};
  &:hover {
    text-decoration: underline;
  }
`;

const TooltipWrapper = styled(Tooltip)`
  left: 0;
  padding: 12px 20px 14px;
  &:before {
    right: 20px;
    border-width: 0 9px 10px 9px;
  }
  ${TopPlayerStatusesWrapper} & {
    ${topPlayerStatusesMobile};
  }
`;

export const DraftTooltip = styled(TooltipWrapper)`
  min-width: 230px;

  ${({ direction }) =>
    direction === 'to-top'
      ? css`
          top: -2px;
        `
      : css`
          top: 60px;
          left: unset;
          right: 8px;

          &:before {
            right: unset;
            left: calc(100% - 30px);
          }
        `}
`;

export const BadgeTooltipWrapper = styled(TooltipWrapper)<BadgeTooltipProps>`
  top: calc(100% + 10px);
  min-width: ${({ contentWidth = 190 }) => contentWidth}px;
  &:before {
    right: unset;
    left: ${({ left }) => left}px;
  }
`;

export default TooltipWrapper;
